export const Logo = ({ size = 36, withWordmark = true }) => (
  <div className="flex items-center gap-3" data-testid="s2s-logo">
    <svg width={size} height={size} viewBox="0 0 48 48" aria-label="S2S logo">
      <rect width="48" height="48" rx="10" fill="#151821" stroke="rgba(245,158,11,0.3)" />
      <path d="M24 7 L41 24 L24 41 L7 24 Z" fill="none" stroke="#F59E0B" strokeWidth="2.5" />
      <path d="M15 29 L24 17 L29 23" fill="none" stroke="#F3F4F6" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M33 27 L24 17" fill="none" stroke="#F59E0B" strokeWidth="3" strokeLinecap="round" />
      <path d="M33 20 L33 27 L26 27" fill="none" stroke="#F59E0B" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13 37 L17 33" stroke="#DC2626" strokeWidth="2.5" strokeLinecap="round" />
      <path d="M31 15 L35 11" stroke="#DC2626" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
    {withWordmark && (
      <div className="leading-none">
        <div className="font-display font-bold text-sm tracking-wide text-[#F3F4F6]">S2S</div>
        <div className="font-mono-tactical text-[10px] tracking-[0.2em] text-amber-500">STREETS 2 STRATEGY</div>
      </div>
    )}
  </div>
);
